module.exports = __webpack_public_path__ + "static/img/91BM-027-ThomasFan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-027-ThomasFan.jpg
// module id = 4Hqr
// module chunks = 0